// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCNjOE_EIuifLpfmj-yWkHyvwjKLuA7K-c",
  authDomain: "gofullthrottle-d3fab.firebaseapp.com",
  projectId: "gofullthrottle-d3fab",
  storageBucket: "gofullthrottle-d3fab.appspot.com",
  messagingSenderId: "499076693311",
  appId: "1:499076693311:web:4e5a867117bde66649278a",
  measurementId: "G-NQ7DX7Q44K",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
